import { render, staticRenderFns } from "./Cm-feed.vue?vue&type=template&id=08b147d0"
import script from "./Cm-feed.vue?vue&type=script&lang=js"
export * from "./Cm-feed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports